import { WestnetzModule } from '../common/westnetz/westnetz.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../common/material/material.module';
import { AufgabeCardComponent } from './aufgabe-card/aufgabe-card.component';
import { ErstelleAufgabeDialogComponent } from './erstelle-aufgabe-dialog/erstelle-aufgabe-dialog.component';
import { AufgabenListComponent } from './aufgaben-list/aufgaben-list.component';
import { AufgabenDashboardComponent } from './aufgaben-dashboard/aufgaben-dashboard.component';
import { AufgabeTypeReadablePipe } from '../common/aufgabe-type-readable/aufgabe-type-readable.pipe';
import { AufgabeTypeImagePipe } from '../common/aufgabe-type-image/aufgabe-type-image.pipe';
import { ZuweisungCardComponent } from './zuweisung-card/zuweisung-card.component';
import { AufgabeTypeFristPrefixPipe } from '../common/aufgabe-frist-type/aufgabe-type-frist-prefix.pipe';
import { ZuweisungGelesenReadablePipe } from '../common/zuweisung-gelesen-readable/zuweisung-gelesen-readable.pipe';
import { AufgabeDetailsComponent } from './aufgabe-details/aufgabe-details.component';
import { FilesizeDirective } from './directives/filesize.directive';
import { ZuweisungDetailsComponent } from './zuweisung-details/zuweisung-details.component';
import { ZuweisungErledigenReadablePipe } from '../common/zuweisung-erledigen-readable/zuweisung-erledigen-readable.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BatchVorgangDialogComponent } from './batch-vorgang-dialog/batch-vorgang-dialog.component';
import { FileUploadComponent } from '../common/file-upload/file-upload.component';


// eslint-disable-next-line max-len

@NgModule({
    declarations: [
        ErstelleAufgabeDialogComponent,
        BatchVorgangDialogComponent,
        AufgabenListComponent,
        AufgabenDashboardComponent,
        AufgabeCardComponent,
        AufgabeTypeReadablePipe,
        AufgabeTypeImagePipe,
        AufgabeTypeFristPrefixPipe,
        ZuweisungGelesenReadablePipe,
        ZuweisungErledigenReadablePipe,
        ZuweisungCardComponent,
        AufgabeDetailsComponent,
        FilesizeDirective,
        ZuweisungDetailsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        ReactiveFormsModule,
        RouterModule,
        WestnetzModule,
        MatProgressSpinnerModule,
        FileUploadComponent,
    ],
    exports: [
        ErstelleAufgabeDialogComponent,
        BatchVorgangDialogComponent,
        AufgabenListComponent,
        AufgabeTypeReadablePipe,
        AufgabeTypeImagePipe,
        AufgabeTypeFristPrefixPipe,
        ZuweisungGelesenReadablePipe,
        ZuweisungErledigenReadablePipe,
    ],
})
export class AufgabeModule {
}
